import { i18n } from '#react/i18n/create'

export const commandMessageDefaults = {
  undo: 'Undo',
  redo: 'Redo',
  selectAll: 'Select all',
  selectInverse: 'Select inverse',
  duplicate: 'Duplicate',
  delete: 'Delete',
  group: 'Group',
  groupSelection: 'Group selection',
  frameSelection: 'Frame selection',
  ungroup: 'Ungroup',
  createComponent: 'Create component',
  createComponentSet: 'Create component set',
  createInstance: 'Create instance',
  detachInstance: 'Detach instance',
  goToMainComponent: 'Go to main component',
  addAutoLayout: 'Add auto layout',
  useAsMask: 'Use as mask',
  removeMask: 'Remove mask',
  bringForward: 'Bring forward',
  bringToFront: 'Bring to front',
  sendBackward: 'Send backward',
  sendToBack: 'Send to back',
  showHide: 'Show/Hide',
  lockUnlock: 'Lock/Unlock',
  unionSelection: 'Union selection',
  subtractSelection: 'Subtract selection',
  intersectSelection: 'Intersect selection',
  excludeSelection: 'Exclude selection',
  flattenSelection: 'Flatten',
  outlineText: 'Outline text',
  outlineStroke: 'Outline stroke',
  booleanOperations: 'Boolean operations',
  flipHorizontal: 'Flip horizontal',
  flipVertical: 'Flip vertical',
  distributeHorizontal: 'Distribute horizontal spacing',
  distributeVertical: 'Distribute vertical spacing',
  moveToPage: 'Move to page',
  setOpacity: 'Set opacity',
  zoomTo100: 'Zoom to 100%',
  zoomToFit: 'Zoom to fit',
  zoomToSelection: 'Focus',
} as const

export const commandMessages = i18n('commands', commandMessageDefaults)
